<template>
  <v-dialog
    :model-value="state.open"
    :persistent="options.persistent"
    :width="options.width"
    @after-leave="service.afterLeave"
    @update:model-value="onModelValueChange"
  >
    <v-card v-if="request">
      <v-toolbar
        v-if="options.title || options.icon"
        class="py-2"
        :color="options.color"
        density="compact"
      >
        <v-icon v-if="options.icon" class="ml-4" :icon="options.icon" />
        <v-toolbar-title v-if="options.title">
          {{ options.title }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text class="confirm-dialog__content pb-3">
        <div class="confirm-dialog__message" v-html="request.message" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="options.buttonFalseText"
          :color="options.buttonFalseColor"
          :flat="options.buttonFalseVariant ? false : options.buttonFalseFlat"
          :variant="options.buttonFalseVariant"
          @click="choose(false)"
        >
          {{ options.buttonFalseText }}
        </v-btn>
        <v-btn
          :color="options.buttonTrueColor"
          :flat="options.buttonTrueVariant ? false : options.buttonTrueFlat"
          :variant="options.buttonTrueVariant"
          @click="choose(true)"
        >
          {{ options.buttonTrueText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useConfirmService } from "@/plugins/confirm";
import { computed } from "vue";

const service = useConfirmService();
const state = service.state;
const request = computed(() => state.current);
const options = computed(() => request.value?.options ?? {});

function choose(result) {
  service.settle(result);
}

function onModelValueChange(value) {
  if (!value && state.open) {
    choose(false);
  }
}
</script>

<style scoped>
.confirm-dialog__content {
  padding-top: 12px !important;
}

.confirm-dialog__message {
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  font-size: 1rem;
  letter-spacing: 0.03125em;
  line-height: 1.5;
}
</style>
